import React, { PureComponent } from 'react';
import { keyframes } from '@emotion/core';
import styled from '@emotion/styled';
import { spinnerColor } from '../../../styles/colors';

const spin = keyframes({
  '0%': { transform: 'rotate(0deg)' },
  '100%': { transform: 'rotate(360deg)' }
});

const Spinner = styled.div({
  border: '6px solid #f3f3f3',
  borderTop: '6px solid rgba(85, 85, 85, 0.2)',
  borderRadius: '50%',
  width: '40px',
  height: '40px',
  animation: `${spin} 2s linear infinite`,
  borderRightColor: spinnerColor,
  borderBottomColor: spinnerColor,
  borderLeftColor: spinnerColor
});

export class MousySpinner extends PureComponent {
  render = () => {
    return <Spinner />;
  };
}



// WEBPACK FOOTER //
// ./src/modules/app/util/MousySpinner.jsx